// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/scheduled_query_run.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UnloadResolverSpec } from "../../common/v1/offline_query_pb";
import { file_chalk_common_v1_offline_query } from "../../common/v1/offline_query_pb";
import type { OfflineQueryMeta } from "./offline_queries_pb";
import { file_chalk_server_v1_offline_queries } from "./offline_queries_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/scheduled_query_run.proto.
 */
export const file_chalk_server_v1_scheduled_query_run: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_common_v1_offline_query, file_chalk_server_v1_offline_queries, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.ScheduledQueryRun
 */
export type ScheduledQueryRun = Message<"chalk.server.v1.ScheduledQueryRun"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: optional string deployment_id = 3;
   */
  deploymentId?: string;

  /**
   * @generated from field: optional string run_id = 4;
   */
  runId?: string;

  /**
   * @generated from field: int64 cron_query_id = 5;
   */
  cronQueryId: bigint;

  /**
   * @generated from field: int64 cron_query_schedule_id = 6;
   */
  cronQueryScheduleId: bigint;

  /**
   * @generated from field: string cron_name = 7;
   */
  cronName: string;

  /**
   * @generated from field: optional string gcr_execution_id = 8;
   */
  gcrExecutionId?: string;

  /**
   * @generated from field: optional string gcr_job_name = 9;
   */
  gcrJobName?: string;

  /**
   * @generated from field: string offline_query_id = 10;
   */
  offlineQueryId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: chalk.server.v1.ScheduledQueryRunStatus status = 13;
   */
  status: ScheduledQueryRunStatus;

  /**
   * @generated from field: optional string blocker_operation_id = 14;
   */
  blockerOperationId?: string;

  /**
   * @generated from field: optional string workflow_execution_id = 15;
   */
  workflowExecutionId?: string;

  /**
   * @generated from field: bool has_errors = 16 [deprecated = true];
   * @deprecated
   */
  hasErrors: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 17;
   */
  completedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.ScheduledQueryRun.
 * Use `create(ScheduledQueryRunSchema)` to create a new message.
 */
export const ScheduledQueryRunSchema: GenMessage<ScheduledQueryRun> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 0);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryRunRequest
 */
export type GetScheduledQueryRunRequest = Message<"chalk.server.v1.GetScheduledQueryRunRequest"> & {
  /**
   * @generated from oneof chalk.server.v1.GetScheduledQueryRunRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: int64 run_id = 1;
     */
    value: bigint;
    case: "runId";
  } | {
    /**
     * @generated from field: string offline_query_id = 2;
     */
    value: string;
    case: "offlineQueryId";
  } | {
    /**
     * @generated from field: string workflow_execution_id = 4;
     */
    value: string;
    case: "workflowExecutionId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: google.protobuf.FieldMask get_mask = 3 [deprecated = true];
   * @deprecated
   */
  getMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryRunRequest.
 * Use `create(GetScheduledQueryRunRequestSchema)` to create a new message.
 */
export const GetScheduledQueryRunRequestSchema: GenMessage<GetScheduledQueryRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 1);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryRunResponse
 */
export type GetScheduledQueryRunResponse = Message<"chalk.server.v1.GetScheduledQueryRunResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ScheduledQueryRun scheduled_query_run = 1;
   */
  scheduledQueryRun?: ScheduledQueryRun;

  /**
   * @generated from field: optional chalk.server.v1.OfflineQueryMeta offline_query = 2 [deprecated = true];
   * @deprecated
   */
  offlineQuery?: OfflineQueryMeta;
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryRunResponse.
 * Use `create(GetScheduledQueryRunResponseSchema)` to create a new message.
 */
export const GetScheduledQueryRunResponseSchema: GenMessage<GetScheduledQueryRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 2);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryRunsRequest
 */
export type GetScheduledQueryRunsRequest = Message<"chalk.server.v1.GetScheduledQueryRunsRequest"> & {
  /**
   * When neither identifier is set, returns runs for every scheduled query in
   * the current environment.
   *
   * id in the CronQuery table
   *
   * @generated from field: int32 cron_query_id = 1;
   */
  cronQueryId: number;

  /**
   * @generated from oneof chalk.server.v1.GetScheduledQueryRunsRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string cron_name = 4;
     */
    value: string;
    case: "cronName";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp start = 5;
   */
  start?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end = 6;
   */
  end?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryRunsRequest.
 * Use `create(GetScheduledQueryRunsRequestSchema)` to create a new message.
 */
export const GetScheduledQueryRunsRequestSchema: GenMessage<GetScheduledQueryRunsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 3);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryRunsResponse
 */
export type GetScheduledQueryRunsResponse = Message<"chalk.server.v1.GetScheduledQueryRunsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ScheduledQueryRun runs = 1;
   */
  runs: ScheduledQueryRun[];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryRunsResponse.
 * Use `create(GetScheduledQueryRunsResponseSchema)` to create a new message.
 */
export const GetScheduledQueryRunsResponseSchema: GenMessage<GetScheduledQueryRunsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 4);

/**
 * @generated from message chalk.server.v1.ScheduledQueryControl
 */
export type ScheduledQueryControl = Message<"chalk.server.v1.ScheduledQueryControl"> & {
  /**
   * @generated from field: int32 cron_query_id = 1;
   */
  cronQueryId: number;

  /**
   * @generated from field: string cron_query_name = 2;
   */
  cronQueryName: string;

  /**
   * @generated from field: chalk.server.v1.CronControlStatus status = 3;
   */
  status: CronControlStatus;

  /**
   * @generated from field: optional string agent_id = 4;
   */
  agentId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string job_config = 7;
   */
  jobConfig?: string;
};

/**
 * Describes the message chalk.server.v1.ScheduledQueryControl.
 * Use `create(ScheduledQueryControlSchema)` to create a new message.
 */
export const ScheduledQueryControlSchema: GenMessage<ScheduledQueryControl> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 5);

/**
 * @generated from message chalk.server.v1.ScheduledQuerySchedule
 */
export type ScheduledQuerySchedule = Message<"chalk.server.v1.ScheduledQuerySchedule"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 cron_query_id = 2;
   */
  cronQueryId: number;

  /**
   * @generated from field: string deployment_id = 3;
   */
  deploymentId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string cron = 5;
   */
  cron: string;

  /**
   * @generated from field: string filename = 6;
   */
  filename: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated string output = 9;
   */
  output: string[];

  /**
   * @generated from field: optional int32 max_samples = 10;
   */
  maxSamples?: number;

  /**
   * @generated from field: optional string recompute_features = 11;
   */
  recomputeFeatures?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp lower_bound = 12;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp upper_bound = 13;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: repeated string tags = 14;
   */
  tags: string[];

  /**
   * @generated from field: repeated string required_resolver_tags = 15;
   */
  requiredResolverTags: string[];

  /**
   * @generated from field: map<string, google.protobuf.Value> planner_options = 16;
   */
  plannerOptions: { [key: string]: Value };

  /**
   * @generated from field: optional string dataset_name = 17;
   */
  datasetName?: string;

  /**
   * @generated from field: optional int32 num_shards = 18;
   */
  numShards?: number;

  /**
   * @generated from field: optional int32 num_workers = 19;
   */
  numWorkers?: number;

  /**
   * @generated from field: optional string input_sql = 20;
   */
  inputSql?: string;

  /**
   * @generated from field: repeated chalk.common.v1.UnloadResolverSpec unload_resolvers = 21;
   */
  unloadResolvers: UnloadResolverSpec[];
};

/**
 * Describes the message chalk.server.v1.ScheduledQuerySchedule.
 * Use `create(ScheduledQueryScheduleSchema)` to create a new message.
 */
export const ScheduledQueryScheduleSchema: GenMessage<ScheduledQuerySchedule> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_scheduled_query_run, 6);

/**
 * @generated from enum chalk.server.v1.ScheduledQueryRunStatus
 */
export enum ScheduledQueryRunStatus {
  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_INITIALIZING = 1;
   */
  INITIALIZING = 1,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_INIT_FAILED = 2;
   */
  INIT_FAILED = 2,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_SKIPPED = 3;
   */
  SKIPPED = 3,

  /**
   * init completed
   *
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_QUEUED = 4;
   */
  QUEUED = 4,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_WORKING = 5;
   */
  WORKING = 5,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_COMPLETED = 6;
   */
  COMPLETED = 6,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_FAILED = 7;
   */
  FAILED = 7,

  /**
   * @generated from enum value: SCHEDULED_QUERY_RUN_STATUS_CANCELED = 8;
   */
  CANCELED = 8,
}

/**
 * Describes the enum chalk.server.v1.ScheduledQueryRunStatus.
 */
export const ScheduledQueryRunStatusSchema: GenEnum<ScheduledQueryRunStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_scheduled_query_run, 0);

/**
 * @generated from enum chalk.server.v1.CronControlStatus
 */
export enum CronControlStatus {
  /**
   * @generated from enum value: CRON_CONTROL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CRON_CONTROL_STATUS_PLAY = 1;
   */
  PLAY = 1,

  /**
   * @generated from enum value: CRON_CONTROL_STATUS_PAUSE = 2;
   */
  PAUSE = 2,
}

/**
 * Describes the enum chalk.server.v1.CronControlStatus.
 */
export const CronControlStatusSchema: GenEnum<CronControlStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_scheduled_query_run, 1);

